<template>
  <div style="display: grid; place-items:center;">
    <div class="gbgContainersScenarioContainer">
      <div class="containersView">
        <aside class="filtersWrapper">
          <div class="containersFilters">
            <div class="headerText">
              FILTER CONTAINERS
            </div>
            <div class="garbClsContainer">
              <div class="garbClsHeader">
                Garbage Class:
              </div>
              <div class="garbClsTypes">
                <article>
                  <section class="garbClsOption">
                    <input type="checkbox" id="plasticCheck" name="plastic" value="plastic" class="garbClsCheckbox"
                      v-model="fPlastic">
                    <label for="plasticCheck">Plastic</label>
                  </section>
                  <section class="garbClsOption">
                    <input type="checkbox" id="organicCheck" name="organic" value="organic" class="garbClsCheckbox"
                      v-model="fOrganic">
                    <label for="organicCheck">Organic</label>
                  </section>
                  <section class="garbClsOption">
                    <input type="checkbox" id="paperCheck" name="paper" value="paper" class="garbClsCheckbox"
                      v-model="fPaper">
                    <label for="paperCheck">Paper</label>
                  </section>
                </article>
              </div>
            </div>
            <div class="garbClsContainer">
              <div class="garbClsHeader">
                Capacity
              </div>
              <div class="garbClsTypes">
                <article>
                  <section class="garbClsOption">
                    <input type="checkbox" id="full" name="full" value="full" class="garbClsCheckbox" v-model="fFull">
                    <label for="full">Full</label>
                  </section>
                  <section class="garbClsOption">
                    <input type="checkbox" id="halfFull" name="halfFull" value="halfFull" class="garbClsCheckbox"
                      v-model="fHalfFull">
                    <label for="halfFull">Half-full</label>
                  </section>
                  <section class="garbClsOption">
                    <input type="checkbox" id="empty" name="empty" value="empty" class="garbClsCheckbox" v-model="fEmpty">
                    <label for="empty">Empty</label>
                  </section>
                </article>
              </div>
            </div>
            <div class="garbClsContainer">
              <div class="serialNHeader">
                Search by serial number
              </div>
              <div class="searchInputContainer">
                <input type="number" id="searchNumber" name="searchNumber" placeholder="0" min="0" class="containerInput"
                  v-model="fQuery">
              </div>
            </div>
          </div>
        </aside>
        <div class="containersList">
          <div class="btnContainer">
            <v-btn v-if="simulationStart == false" class="ma-2 pa-2 mx-auto" color="success" small depressed rounded
              @click="toggleSimulation()">
              Initiate simulation
            </v-btn>
            <v-btn v-else class="ma-2 pa-2 mx-auto" color="error" small depressed rounded
              @click="toggleSimulation()">
              Stop simulation
            </v-btn>
          </div>

          <div class="containersBoxMap">
            <!--AQUI VA EL MAPA RECHULON-->
            <div ref="map-root" id="contMap"></div>
            <div id="popup" class="ol-popup">
              <a href="#" id="popup-closer" class="ol-popup-closer"></a>
              <div id="popup-content"></div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import containersGarbageIIOTAPI from '@/services/containersGarbageIIOTAPI';
import View from 'ol/View'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import Feature from 'ol/Feature';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import { Style, Icon } from 'ol/style';
import { useGeographic, toLonLat } from 'ol/proj.js';
import Point from 'ol/geom/Point';
import Overlay from 'ol/Overlay';
import { toStringHDMS } from 'ol/coordinate';

export default {
  name: "ContainerMapView",
  components: {
  },
  sse: {
    cleanup: true
  },
  data() {
    return {
      start: true,
      simulationStart: false,
      items: [],
      fPlastic: false,
      fOrganic: false,
      fPaper: false,
      fFull: false,
      fHalfFull: false,
      fEmpty: false,
      fQuery: 0,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 13,
      center: [36.84, -2.388],
      iconOrganic: new Icon({
        anchor: [100, 100],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        height: 25,
        width: 25,
        src: require('@/assets/scenarios/garbage/container/organic.png')
      }),
      iconPlastic: new Icon({
        anchor: [100, 100],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        height: 25,
        width: 25,
        src: require('@/assets/scenarios/garbage/container/plastic.png')
      }),
      iconPaper: new Icon({
        anchor: [100, 100],
        anchorXUnits: 'pixels',
        anchorYUnits: 'pixels',
        height: 25,
        width: 25,
        src: require('@/assets/scenarios/garbage/container/paper.png')
      }),
      eventSource: null,
    };
  },
  computed: {
    filteredContainers() {

      let tempCont = this.items;
      let allTypes = this.fPlastic && this.fOrganic && this.fPaper;
      let allCapacities = this.fFull && this.fHalfFull && this.fEmpty;
      if (allTypes) {
        tempCont = this.items;
      }

      if (allCapacities) {
        tempCont = this.items;
      }

      tempCont = tempCont.filter((item) => {

        if (!allTypes) {
          if (this.fPlastic && item.garbageClass == "plastic") {
            return item;
          }

          if (this.fOrganic && item.garbageClass == "organic") {
            return item;
          }

          if (this.fPaper && item.garbageClass == "paper") {
            return item;
          }
        }

        if (!allCapacities) {
          let itmCapacity = (item.capacity / item.totalCapacity) * 100;

          if (this.fFull && itmCapacity >= 95) {
            return item;
          }

          if (this.fHalfFull && itmCapacity >= 45 && itmCapacity < 75) {
            return item;
          }

          if (this.fEmpty && itmCapacity < 5) {
            return item;
          }
        }

        if (this.fQuery && item.serialNumber == this.fQuery) {
          return item;
        }

      });

      if (tempCont.length == 0) {
        tempCont = this.items;
      }
      return tempCont;
    }
  },
  watch: {
    filteredContainers() {
      this.editLayers();
    }
  },
  async beforeMount() {
    this.eventSource = new EventSource('https://acgsaas.ual.es/things/acg:lab:virtual-containers/property/containersDetails/sse');
    this.eventSource.addEventListener('message', (e) => {
      console.log(JSON.parse(e.data));
      this.items = JSON.parse(e.data);
      //this.editLayers();
    });
  },
  beforeDestroy() {
    if(this.eventSource != null)
      eventSource.close();
  },
  async mounted() {
    await this.getContainers();
  },
  methods: {
    async toggleSimulation() {
      containersGarbageIIOTAPI.put('/runApp', { simulation: !this.simulationStart }, { headers: { 'Content-Type': 'application/json' } }).then((response) => {
        console.log(response.data);
        this.simulationStart = !this.simulationStart;
      });
    },
    async getContainers() {
      containersGarbageIIOTAPI.get('/property/containersDetails').then((response) => {
        this.items = response.data;
        this.setupMap();
      })
    },
    async setupMap() {

      useGeographic();

      const center = [this.center[1], this.center[0]];

      this.map = new Map({
        target: this.$refs['map-root'],
        view: new View({
          center: center,
          zoom: 12,
          minZoom: 2,
          maxZoom: 19,
        }),
        layers: [
          new TileLayer({
            source: new OSM(),
          }),
        ]
      });

      var contOrgMarkerStyle = new Style({
        image: this.iconOrganic
      })

      var contPlasMarkerStyle = new Style({
        image: this.iconPlastic
      })

      var contPaperMarkerStyle = new Style({
        image: this.iconPaper
      })

      var contFT = [];

      this.filteredContainers.forEach((c) => {

        var cft = new Feature({
          geometry: new Point([c.location.lng, c.location.lat]),
          name: c.serialNumber
        })

        if (c.garbageClass == "organic") {
          var contMarkerStyle = contOrgMarkerStyle;
        } else if (c.garbageClass == "plastic") {
          var contMarkerStyle = contPlasMarkerStyle;
        } else if (c.garbageClass == "paper") {
          var contMarkerStyle = contPaperMarkerStyle;
        }
        cft.setStyle(contMarkerStyle)
        contFT.push(cft);
      })

      var vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: contFT
        })
      });

      // Agrega la capa de los contenedores al mapa
      this.map.addLayer(vectorLayer);

      // Popup things
      var container = document.getElementById('popup');
      var content = document.getElementById('popup-content');
      var closer = document.getElementById('popup-closer');

      var overlay = new Overlay({
        element: container,
        
      });

      this.map.addOverlay(overlay);

      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };
      
      this.map.on('singleclick', function (evt) {
        if(evt.map.hasFeatureAtPixel(evt.pixel)){
          const coordinate = evt.coordinate;
          
          
          content.innerHTML = '<div class="upperContent"><div><span><strong class="serialNumberStronger">SERIAL NUMBER:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.name + '</span></div><div class="capacityCont"><strong>' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageLevel + '</strong></div></div><div class="lowerContent"><p><span class="garbClsSpan">GARBAGE CLASS: </span>'+ evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageClass +'</p></div>'
          //content.innerHTML = '<p><strong>Contenedor</strong> Nº' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.name + '</p><p><strong>Garbage Class:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageClass + '</p><p><strong>Garbage Level:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageLevel + '</p>';
          overlay.setPosition(coordinate);
        }
        
      });
    

    },
    editLayers() {
      useGeographic();

      this.map.getLayers().forEach((layer) => {
        if (layer instanceof VectorLayer) {
          this.map.removeLayer(layer);
        }
      })

      var contOrgMarkerStyle = new Style({
        image: this.iconOrganic
      })

      var contPlasMarkerStyle = new Style({
        image: this.iconPlastic
      })

      var contPaperMarkerStyle = new Style({
        image: this.iconPaper
      })

      var contFT = [];

      this.filteredContainers.forEach((c) => {

        var cft = new Feature({
          geometry: new Point([c.location.lng, c.location.lat]),
          name: c.serialNumber,
          garbageClass: c.garbageClass,
          garbageLevel: c.capacity + '/' + c.totalCapacity
        })

        if (c.garbageClass == "organic") {
          var contMarkerStyle = contOrgMarkerStyle;
        } else if (c.garbageClass == "plastic") {
          var contMarkerStyle = contPlasMarkerStyle;
        } else if (c.garbageClass == "paper") {
          var contMarkerStyle = contPaperMarkerStyle;
        }
        cft.setStyle(contMarkerStyle)
        contFT.push(cft);
      })

      var vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: contFT
        })
      });

      // Agrega la capa de los contenedores al mapa
      this.map.addLayer(vectorLayer);

      // Popup things
      var container = document.getElementById('popup');
      var content = document.getElementById('popup-content');
      var closer = document.getElementById('popup-closer');

      var overlay = new Overlay({
        element: container,
        
      });

      this.map.addOverlay(overlay);

      closer.onclick = function () {
        overlay.setPosition(undefined);
        closer.blur();
        return false;
      };

      this.map.on('singleclick', function (evt) {
        if(evt.map.hasFeatureAtPixel(evt.pixel)){
          const coordinate = evt.coordinate;
          content.innerHTML = '<div class="upperContent"><div style="display:grid;place-items:center; margin-right:5px;"><span><strong class="serialNumberStronger">SERIAL NUMBER:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.name + '</span></div><div class="capacityCont"><strong>' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageLevel + '</strong></div></div><div class="lowerContent"><p><span class="garbClsSpan"><strong>GARBAGE CLASS:</strong> '+ evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageClass.toUpperCase() +'</span></p></div>'
          //content.innerHTML = '<p><strong>Contenedor</strong> Nº' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.name + '</p><p><strong>Garbage Class:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageClass + '</p><p><strong>Garbage Level:</strong> ' + evt.map.getFeaturesAtPixel(evt.pixel)[0].values_.garbageLevel + '</p>';
          overlay.setPosition(coordinate);
        }
        
      });
    }
  },
}
</script>

<style>
.containersView {
  display: grid;
  max-width: 1150px;
  height: 100%;
}

.gbgContainersScenarioContainer {
  display: grid;
  place-items: center;
  background-color: #F6F6F6;
  border-radius: 12px;
  padding: 0rem 0rem 0rem 0rem;
  margin: 1rem 0;
  border: 1px solid #AAA;
  height: 65vh;
}

.containersFilters {
  display: grid;
  place-items: center;
  width: 100%;
}

.btnContainer {
  position: absolute;
  z-index: 1;
  top: 0;
}

.containersList {
  display: grid;
  margin: 0;

  height: 100%;
  width: 100%;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  position: relative;
}

.containersBoxMap {
  display: grid;
  height: 100%;
  width: 100%;
  position: relative;
  z-index: 0;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.filtersWrapper {
  height: 100%;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  background-color: #C6C6C6;
  border-right: 1px solid #BBB;
}

.headerText {
  font-weight: 600;
  font-size: 1rem;
  border-top-left-radius: 10px;
  color: #F6F6F6;
  margin: 1rem;
  background-color: #B0B5BF;
  height: 100%;
  width: 100%;
  display: grid;
  place-items: center;
}

.garbClsContainer {
  display: grid;
  place-items: center;
  width: 100%;
  background-color: #D9D9D9;
  color: #63635B;
  font-weight: 500;
  border-bottom: 1px solid #BBB;
}

.garbClsTypes {
  background-color: #C6C6C6;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  margin: 0.5em 0;
}

.garbClsCheckbox {
  appearance: none;
  background-color: #D9D9D9;
  border: 0.15em solid #F6F6F6;
  height: 1.15em;
  width: 1.15em;
  border-radius: 0.15em;
  display: grid;
  place-content: center;
}

.garbClsCheckbox::before {
  content: "";
  width: 0.65em;
  height: 0.65em;
  transform: scale(0);
  transition: 120ms transform ease-in-out;
  box-shadow: inset 1em 1em var(#D9D9D9);
}

.garbClsCheckbox:checked::before {
  transform: scale(1);
  background-color: #F6F6F6;
}

.garbClsHeader {
  font-size: 1rem;
}

.serialNHeader {
  font-size: 0.9rem;
}

.garbClsOption {
  display: grid;
  grid-template-columns: 1fr 5fr;
  place-items: center;
  width: 100%;
}

.searchInputContainer {
  background-color: white;
  border-radius: 24px;
  margin-bottom: 10px;
  text-align: start;
  display: grid;
  place-items: center;
  padding-left: 10px;
  height: 80%;
  width: 80%;
}

.containerInput {
  font-weight: 500;
  -moz-appearance: textfield;
}

.containerInput::-webkit-inner-spin-button,
.containerInput::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

#map {
  height: 100%;
  width: 100%;
  position: inherit;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;

}

.ol-popup {
  position: absolute;
  background-color: #444;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  padding: 15px;
  border-radius: 10px;
  border: 1px solid #cccccc;
  bottom: 12px;
  left: -50px;
  min-width: 300px;
  color: #F6F6F6;
}

.ol-popup:after,
.ol-popup:before {
  top: 100%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ol-popup:after {
  border-top-color: white;
  border-width: 10px;
  left: 48px;
  margin-left: -10px;
}

.ol-popup:before {
  border-top-color: #cccccc;
  border-width: 11px;
  left: 48px;
  margin-left: -11px;
}

.ol-popup-closer {
  text-decoration: none;
  position: absolute;
  top: 2px;
  right: 8px;
}

.ol-popup-closer:after {
  content: "✖";
}

.upperContent {
    display: grid;    
    grid-template-columns: auto auto;
    justify-content: space-between;
    width: 100%;
    padding: 10px;
    vertical-align: middle;
    margin-bottom: 1rem;
}

.serialNumberStronger {
    font-weight: 500;
}

.capacityCont {
    display: grid;
    place-items: center;
    width: 65px;
    height: 35px;
    background-color: #7EA53F;
    color: #25262D;
    font-weight: 500;
    border-radius: 5px;
    margin: 5px;
}

.lowerContent {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    width: 100%;
    padding: 0 10px;
    vertical-align: middle;
    position: sticky;
}
.garbClsSpan {
    font-weight: 500;
    font-size: 0.7rem;
}


</style>